<template>
  <div id="app">
    <router-view>
      <!-- top level router component(s) -->
    </router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('/assets/font/gilroy.css');
@import url('/assets/icons/smrtb-icons.css');
@import url('vue2-animate/dist/vue2-animate.min.css');

html, body, #app {
  height: 100%;
}
#app {
  font-family: 'Gilroy', Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#toprogress {
  z-index: 999999; /* otherwise the progress bar gets hidden behind cards and sidebars */
}
thead th {
  border-width: 2px !important; /* fcking fck */
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}
.table td, th {
  /* bootstrap sets this shit at the top my dude */
  vertical-align: middle !important;
}
*:focus {
  outline: none !important;
}
/*
  turn cursor into the little pointy hand when it's over an element
  Also prevents text within the element from being highlighted, to reinforce that it's a button
*/
.cursor-pointer {
  cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
.cursor-default {
  cursor: default;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
</style>



// WEBPACK FOOTER //
// src/App.vue